import { box, drawBox, faceQuad, faces, frontFace } from './iso.js';
import type { FurniDrawer } from './iso.js';

/** Drawers for the newsroom TVs (see protocol furniture/media.ts). */

/** A studio TV on a stand; `screen` and `accent` colour what it is showing. */
function newsTv(screen: string, accent: string): FurniDrawer {
  return (pc, rotation) => {
    const face = frontFace(rotation) ?? 'left';
    // Stand, then the screen housing.
    drawBox(pc, box(-0.42, 0.42, -0.26, 0.26, 0, 12, faces('#3a3240', '#4d4456')));
    drawBox(pc, box(-0.44, 0.44, -0.08, 0.08, 12, 50, faces('#1e1f27', '#2f313b')));
    const at = 0.08;
    faceQuad(pc, face, at, -0.4, 0.4, 15, 47, '#0b0f1a');
    faceQuad(pc, face, at, -0.36, 0.36, 18, 44, screen);
    // A news-style layout: headline bar, picture and ticker.
    faceQuad(pc, face, at + 0.005, -0.36, 0.36, 18, 23, accent);
    faceQuad(pc, face, at + 0.005, -0.32, -0.02, 27, 41, '#e8f1f8');
    faceQuad(pc, face, at + 0.005, 0.02, 0.32, 36, 41, '#e8f1f8');
    faceQuad(pc, face, at + 0.005, 0.02, 0.32, 28, 33, '#e8f1f8');
    // A small red "live" light on the corner.
    faceQuad(pc, face, at + 0.006, 0.28, 0.34, 42, 44, '#ff3b3b');
  };
}

export const MEDIA_DRAWERS: Record<string, FurniDrawer> = {
  news_tv_updates: newsTv('#2a5fa8', '#f0bf36'),
  news_tv_stats: newsTv('#23805a', '#ffffff'),
  news_tv_events: newsTv('#a83a3a', '#f0bf36'),
};
